import { LayoutDashboard, MessageSquare } from 'lucide-react';
import { schedulingAiEnabled } from '@/lib/use-scheduling-ai-enabled';

/**
 * The name of the rail's `dashboard` slot (rail item, top-bar crumb, Back target).
 *
 * With `VITE_SCHEDULING_AI` on, the slot shows the WhatsApp inbox (inbox-dashboard-gate.tsx, same check), so it is
 * named "Inbox": "Dashboard" is not what it shows (Andrew, demo planning 27 Oct). With the flag off the
 * slot is still the "Dashboard — coming soon" placeholder, and keeps its name. The flag is inlined at
 * build time, so this is a constant for the build; `enabled` is only passed by tests.
 */
export function dashboardNavLabel(enabled: boolean = schedulingAiEnabled()): string {
  return enabled ? 'Inbox' : 'Dashboard';
}

/** The rail icon for the same slot: a message bubble when it is the inbox. */
export function dashboardNavIcon(enabled: boolean = schedulingAiEnabled()) {
  return enabled ? MessageSquare : LayoutDashboard;
}
